import { initializeGoogleLoader } from '/src/common/utils/GoogleLoader';
import { CODE_ENV_LIST } from '@/common/constants/ConstCode';
const { GOOGLE_MAPS_KEY } = CODE_ENV_LIST;

let geoCoder;
let geoCoderStatus;
let loader = initializeGoogleLoader(GOOGLE_MAPS_KEY);

const importLibrary = async () => {
  const google = await loader.importLibrary('geocoding');
  geoCoder = new google.Geocoder();
  geoCoderStatus = google['GeocoderStatus'];
};

const reverseGeocode = async (lat, lng) => {
  if (!geoCoder) await importLibrary();
  let geoResult = { address: '', latitude: lat, longitude: lng };
  const latlng = {
    lat: parseFloat(lat),
    lng: parseFloat(lng)
  };
  await geoCoder.geocode({ location: latlng }, (result, status) => {
    if (status === geoCoderStatus['OK']) {
      geoResult.address =
        result
          .filter(
            (elem) => (elem.types ?? []).includes('street_address')
            // (elem.types ?? []).includes('locality')
            // (elem) => (elem.types ?? []).includes('route')
          )
          ?.pop()?.formatted_address ?? '';
    }
  });
  return geoResult;
};
const geocode = async (location = '') => {
  if (!geoCoder) await importLibrary();
  let geoResult = { address: '', latitude: 0, longitude: 0 };
  await geoCoder.geocode({ address: location }, (result, status) => {
    if (status == geoCoderStatus['OK']) {
      const { formatted_address, geometry } = result[0];

      const { location } = geometry;
      const { lat, lng } = location;
      geoResult = {
        address: formatted_address,
        latitude: lat(),
        longitude: lng()
      };
    }
  });

  return geoResult;
};

export { geocode, reverseGeocode };
